<div class="main-page static-container">
  <div class="container static-page" *ngIf="!innerHtml?.is_full_screen">
    <div
      class="static-container"
      [class.contact-us]="innerHtml?.slug == 'contact-us'"
    >
      <div class="page-title flex" (click)="onBack()">
        <img src="assets/images/icons/left-arrow.svg" alt="Arrow Left Icon" />
        <p>{{ innerHtml?.title }}</p>
      </div>
      <app-faq model="faq" *ngIf="innerHtml?.slug == 'faq'"></app-faq>
      <div
        class="page-data"
        [innerHtml]="innerHtml?.content"
        [class.return-policy]="innerHtml.slug == 'return-policy'"
      ></div>
    </div>
  </div>
  <div
    *ngIf="innerHtml?.is_full_screen"
    [class.contact-us]="innerHtml?.slug == 'contact-us'"
    [class.return-policy]="innerHtml.slug == 'return-policy'"
    [innerHtml]="innerHtml?.content"
  ></div>
</div>